import iScroll from "iscroll";
import _ from "lodash";
import React, { Component } from "react";
import ReactIScroll from "react-iscroll";
import { connect } from "react-redux";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { isNull } from "util";
import { getDonorsFromFolder } from "../../../utils/donorHelpers";
import { dp } from "../../../utils/shared.js";
import DonorFullPage from "../Tampa/DonorFullPage";
import MenuOmaha from "./MenuOmaha";
import get from "lodash/get";
const QuillDeltaToHtmlConverter = require("quill-delta-to-html");

class OmahaRecognitionList extends Component {
  constructor(props) {
    super(props);

    this._subscribeModule = null;
    this._rowWrapperRef = null;
    this._backButtonRef = null;

    this._columns = 2;
    this._rows = 6;
    this._fontColor = "#ffffff";
    this._backdropColor = "#000000";
    this._footerText = "";
    this._parentCategoryName = ""; //used to stash name so state can switch to empty string
    this._ni_options = {};
    this._metaCycleTimeout = null;
    this._listCycleTime = 8000;
    this._marginRight = this.props.screen.sv.width * 0.0375;
    this._fontClass = "gfont_roboto";
    this._donorCategories = null;
    this._recognitionOptionsRef = null;
    this._descriptionRef = null;

    this._donorGroups = [];

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");

    // const rootFolderId = _.get(this.props.content, "settings.selected_root_folder", null);
    const rootFolder = this.props.content.story_categories.find((folder) => folder.id === Number(id));
    this._colorPallette = _.get(rootFolder, "contents.custom_fields.color_pallette.val.value", "golisano");

    const descriptionRichText = new QuillDeltaToHtmlConverter(
      _.get(rootFolder, "contents.custom_fields.description.val.ops", {}),
      {}
    ).convert();

    const description = descriptionRichText === "<p><br/></p>" ? null : descriptionRichText;

    this.state = {
      rootFolder,
      description,
      donorGroup: 0,
      listWrapperHeight: 80
    };
  }

  componentDidMount() {
    this.setRefs();
  }

  componentDidUpdate() {
    this.setRefs();
  }

  checkSwipeAnimation = () => {
    const wrapperHeight = this._wrapperDiv.getBoundingClientRect().height;
    const contentHeight = this._innerDivRef.getBoundingClientRect().height;

    if (this.props.handleSwipeAnimation) {
      this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
    }
  };

  handleScrollStart = () => {
    if (this.props.cancelSwipeAnimation) {
      this.props.cancelSwipeAnimation();
    }
  };

  setRefs = () => {
    if (!this._backButtonRef) {
      setTimeout(() => {
        this.setRefs();
      }, 100);
    } else {
      this._backButtonRef.addEventListener("click", this.goBack);
    }

    if (this._descriptionRef) {
      // Get the height of the description
      const descriptionHeight = this._descriptionRef.getBoundingClientRect().height;
      const headerHeight = this.props.screen.screenHeight * 0.0716;
      const footerHeight = this.props.screen.screenHeight * 0.055;
      const listWrapperHeight =
        ((this.props.screen.screenHeight - descriptionHeight - headerHeight - footerHeight) /
          this.props.screen.screenHeight) *
        100;
      if (listWrapperHeight !== this.state.listWrapperHeight) {
        this.setState({
          listWrapperHeight
        });
      }
    }
  };

  goBack = () => {
    const displayModuleId = this.props.module.id;
    const displayModule = this.props.content.dm_active.find((dm) => dm.id === displayModuleId);
    const folderId = get(displayModule, "contents.folder", null);

    if (folderId !== null) {
      const childStories = this.props.content.folder_modules.filter(
        (fm) => fm.folder === Number(folderId) && fm.model === "story"
      );
      const childStoryCategories = this.props.content.story_categories.filter(
        (sc) => sc.parent_category === Number(folderId)
      );

      const totalItems = childStories.length + childStoryCategories.length;
      if (totalItems === 1) {
        // Redirect to home
        this.props.navRoute("/omaha/nav", null);
      } else {
        // Redirect to stories
        this.props.navRoute("/omaha/stories", displayModule);
      }
    }
  };

  getBackgroundImage = () => {
    let defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };

    if (this.props.screensNumber === 2) {
      defaultImg.file_name = "default_double_screen.jpg";
    }

    try {
      let backgroundReference = this.props.module.contents.custom_fields.background_reference_recognition_list_view.val;
      let assetsSlideShow = _.find(this.props.content.dm_active, function (o) {
        return o.name.includes("Assets");
      });
      let asset = _.indexOf(assetsSlideShow.contents.names, backgroundReference);

      if (!asset || asset === undefined) {
        return dp(this.props.screen, defaultImg);
      }

      return dp(this.props.screen, assetsSlideShow.contents.images[asset]);
    } catch (e) {
      return dp(this.props.screen, defaultImg);
    }
  };

  getIconImage = () => {
    // return dp(this.props.screen, _.get(this.props.module, "contents.images[1]", null), null);
    let category = this.props.module.folder;
    let foundDm = _.filter(this.props.content.dm_active, (dm) => {
      return Number(dm.contents.story_category) === category;
    });

    let icon = null;
    if (foundDm.length > 0) {
      icon = foundDm[0].module_contents.icon;
    }

    return dp(this.props.screen, icon);
  };

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, "settings.selected_root_folder", null);
    const menu = this.props.content.story_categories.find((folder) => {
      const type = _.get(folder, "contents.custom_fields.folder_type.val.value", null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    const rootFolder = this.props.content.story_categories.find((folder) => folder.id === Number(rootFolderId));
    this._arrowIcon = dp(this.props.screen, _.get(menu, "contents.images[0]", null), null);
    this._colorPallette = _.get(rootFolder, "contents.custom_fields.color_pallette.val.value", "golisano");
    const subscribeModule = this.props.content.story_categories.find((folder) => {
      const type = _.get(folder, "contents.custom_fields.folder_type.val.value", null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  };

  renderCategories = () => {
    if (isNull(this._donorCategories)) {
      let categoryWrapStyle = {
        boxSizing: "border-box",
        width: this.props.screen.screenWidth * 0.78838174273858921162,
        background: "white",
        paddingBottom: this.props.screen.screenHeight * 0.01875,
        paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
        borderRadius: 10,
        paddingLeft: this.props.screen.screenWidth * 0.074074074,
        paddingRight: this.props.screen.screenWidth * 0.074074074,
        marginBottom: this.props.screen.screenHeight * 0.03125
      };

      // Find child story_categories aka folders
      const donorGroups = this.props.content.story_categories.filter(
        (sc) => sc.parent_category === Number(this.state.rootFolder.id)
      );

      const descriptionRichText = new QuillDeltaToHtmlConverter(
        _.get(
          this._donorGroups[this.state.donorGroup],
          "contents.custom_fields.description.val.ops",
          _.get(this._donorGroups[this.state.donorGroup], "contents.custom_fields.description.default.ops", null)
        ),
        {}
      ).convert();

      const donorGroupsWithChildren = donorGroups.map((group, i) => {
        const donors = getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, group.id);
        const orderedDonors = _.orderBy(donors, ["sorting_name", "asc"]);
        let donorFullPageWidth =
          this.props.screen.screenWidth * 0.78838174273858921162 - this.props.screen.screenWidth * 0.074074074 * 2;
        const hideTitle = _.get(group, "contents.custom_fields.hide_title.val", false);

        const donorList = (
          <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ ...categoryWrapStyle }} className="opensans-regular">
              {i === 0 ? (
                <div
                  style={{
                    lineHeight: "1.5625vh",
                    paddingRight: this.props.screen.screenHeight * 0.01562,
                    paddingLeft: this.props.screen.screenHeight * 0.01562
                  }}
                  dangerouslySetInnerHTML={{ __html: descriptionRichText }}
                />
              ) : null}
              {hideTitle !== true ? (
                <div>
                  <h1
                    style={{
                      paddingRight: this.props.screen.screenHeight * 0.01562,
                      paddingLeft: this.props.screen.screenHeight * 0.01562,
                      fontSize: this.props.screen.screenHeight * 0.021875
                    }}
                  >
                    {group.name}
                  </h1>
                </div>
              ) : null}
              <div>
                <DonorFullPage
                  columns={this._columns}
                  custom1x2={"<span />"}
                  donorData={orderedDonors}
                  fontClass={this._fontclass}
                  height={this.props.screen.screenHeight * 0.115}
                  overrideFontSize={0}
                  overrideMarginRight={0}
                  overridePadding={this.props.screen.screenHeight * 0.01562}
                  rows={this._rows}
                  screen={this.props.screen}
                  sort="column"
                  width={donorFullPageWidth}
                />
              </div>
            </div>
          </div>
        );

        return <div key={i}>{donorList}</div>;
      });
      return donorGroupsWithChildren;
    }
  };

  render() {
    const background = this.getBackgroundImage();
    const backButton = dp(this.props.screen, null, { path: "/img/omaha/general/", file_name: "back_grey.png" });
    const unit = this.props.screen.r9_16.p10;
    const textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
    let headlineFontSize = "3.5vh";
    if (this.state.changeHeadlineFontSize) {
      headlineFontSize = this.state.headlineFontSize;
    }

    return (
      <div>
        <div
          style={{
            position: "absolute",
            width: this.props.screen.screenWidth,
            height: this.props.screen.r9_16.height,
            backgroundSize: "contain",
            backgroundImage: "url(" + background + ")"
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#8c827a",
              height: "7.16vh",
              width: "100%",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <span
              ref={(el) => (this._headlineRef = el)}
              style={{
                textShadow: textShadow,
                fontSize: headlineFontSize,
                fontWeight: "bold",
                marginTop: "1.83vh",
                marginBottom: "1.83vh"
              }}
            >
              {this.props.module.name.toUpperCase()}
            </span>
            <img
              className="shadowed-image"
              style={{ position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" }}
              src={this._icon}
              alt=""
            />
          </div>
          {/* End of Header */}

          <div style={{ position: "relative", height: "87.34vh", width: "100%" }}>
            {this.state.description && (
              <div
                ref={(el) => (this._descriptionRef = el)}
                style={{
                  position: "relative",
                  // fontSize: "2.3vh",
                  color: "#6f6259",
                  width: "100%",
                  maxHeight: "15vh",
                  marginBottom: "3vh",
                  marginTop: "3.84vh",
                  // textAlign: "left",
                  // fontWeight: "bold",
                  overflow: "hidden"
                }}
              >
                <div style={{ position: "relative", width: "39.37vh", margin: "auto" }}>
                  <div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.state.description }}></div>
                </div>
              </div>
            )}

            <div style={{ position: "relative", height: "100%", width: " 100%" }}>
              {this.state.description && (
                <div
                  className="topgradblackP25"
                  style={{ position: "relative", width: "100%", height: unit * 0.25, top: "1.4vh" }}
                />
              )}
              <div style={{ position: "absolute", height: "100%", width: "100%", backdropFilter: "blur(6px)" }} />
              <div
                ref={(el) => (this._wrapperDiv = el)}
                style={{
                  display: "block",
                  color: "black",
                  width: "85%",
                  height: !this.state.description ? "100%" : this.state.listWrapperHeight * 1.035 + "%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  touchAction: "none"
                }}
              >
                <ReactIScroll
                  ref={(el) => (this.iScroller = el)}
                  iScroll={iScroll}
                  onScrollStart={this.handleScrollStart}
                  options={{
                    mouseWheel: true,
                    scrollbars: false,
                    scrollX: false,
                    scrollY: true,
                    probeType: 2,
                    bounce: false,
                    momentum: true,
                    deceleration: 0.005,
                    useTransition: true,
                    disableTouch: false,
                    disablePointer: false,
                    disableMouse: false,
                    tap: true
                  }}
                  onRefresh={this.initializeIScroll}
                >
                  <CSSTransitionGroup
                    component="div"
                    transitionName="example"
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}
                  >
                    <div ref={(el) => (this._innerDivRef = el)} key={this.state.donorGroup}>
                      <div style={{ height: "2.5vh" }}></div>
                      {this.renderCategories()}
                    </div>
                  </CSSTransitionGroup>
                </ReactIScroll>
              </div>
            </div>

            <img
              ref={(el) => (this._backButtonRef = el)}
              src={backButton}
              style={{ position: "absolute", left: "1.3vh", bottom: "8vh", width: "2.8vh" }}
              alt=""
            />
          </div>

          <div style={{ position: "absolute", bottom: "0vh", width: "100%", textAlign: "center" }}>
            <MenuOmaha navRoute={this.props.navRoute} currentModuleId={this.props.module.display_module_id} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    donors: state.donors
  };
};

export default connect(mapStateToProps, null)(OmahaRecognitionList);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/OmahaRecognitionList.jsx